// extracted by mini-css-extract-plugin
export default {"body":"style_body__ogmMr","loader":"style_loader__bI6hB","pgfill":"style_pgfill__9TAFZ"};